import { memo } from 'react'
import { cn } from '@quickmd-llc/design-system'
import { sanitizeNoteHtml } from '../../../../../utils/noteHtmlSanitizer'
import './NoteItem.scss'

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
export const NoteItem = memo(({ id, providerName, dateTime, noteValue, isTheLast }) => (
  <div className={cn('note-item-main-wrapper', isTheLast && 'note-item-main-wrapper--last-item')}>
    <div className='note-item-text note-item-provider-name'>{providerName}</div>
    <div className='note-item-text note-item-provider-date-time'>{dateTime}</div>
    <div
      id={id}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: sanitizeNoteHtml(noteValue) }}
      className='note-item-text note-item-provider-date-note-value'
    />
  </div>
))
